"use strict";

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Icon_1 = require("../../atoms/Icon");

var Paragraph_1 = require("../../atoms/Paragraph");

var Picture_1 = require("../../atoms/Picture");

var TextSection_1 = require("../TextSection");

var defaultProps = {
  headline: "",
  leadText: "",
  scrollerText: ""
};

exports.Stage = function (_a) {
  var className = _a.className,
      headline = _a.headline,
      leadText = _a.leadText,
      scrollerText = _a.scrollerText,
      button = _a.button,
      imgAltText = _a.imgAltText,
      imageSrc = _a.imageSrc,
      imageSrcMobile = _a.imageSrcMobile,
      imageSrcTablet = _a.imageSrcTablet,
      imageSrcDesktop = _a.imageSrcDesktop,
      imageFocalPoint = _a.imageFocalPoint,
      theme = _a.theme,
      nextTheme = _a.nextTheme;
  var scrollAnchor;

  var onScrollerClick = function onScrollerClick() {
    if (scrollAnchor) {
      // TODO use helper function here (sticky header)
      scrollAnchor.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "start"
      });
    }
  };

  var srcMobile = imageSrcMobile ? imageSrcMobile : imageSrc;
  var srcTablet = imageSrcTablet ? imageSrcTablet : imageSrc;
  var srcDesktop = imageSrcDesktop ? imageSrcDesktop : imageSrc;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "stage", className, CSSPrefix_1.prefixEnumClassNames(theme)])
  }, React.createElement("div", {
    className: CSSPrefix_1.lsgPre + "stage-keyvisual"
  }, React.createElement(Picture_1.Picture, {
    asBackgroundImage: true,
    src: {
      "default": srcMobile,
      lg: srcDesktop,
      sm: srcTablet,
      xs: srcMobile
    },
    alt: imgAltText,
    backgroundFocalPoint: imageFocalPoint
  }), React.createElement("div", {
    className: CSSPrefix_1.lsgPre + "stage-gradient"
  })), React.createElement(TextSection_1.TextSection, {
    title: headline,
    titleSize: TextSection_1.TextSection.Sizes.H1
  }, React.createElement(Paragraph_1.Paragraph, {
    className: CSSPrefix_1.lsgPre + "stage-leadtext",
    size: Paragraph_1.Paragraph.Sizes.LEAD
  }, leadText), button && React.cloneElement(button, {
    className: CSSPrefix_1.lsgPre + "stage-button"
  })), React.createElement("div", {
    className: CSSPrefix_1.lsgPre + "stage-scroller"
  }, React.createElement("div", {
    className: CSSPrefix_1.lsgPre + "stage-scroller-inner",
    onClick: onScrollerClick
  }, React.createElement("div", null, scrollerText), React.createElement(Icon_1.Icon, {
    name: Icon_1.Icon.Names.interaction_arrows_chevronDown,
    className: CSSPrefix_1.lsgPre + "stage-scroller-icon"
  })))), React.createElement("div", {
    ref: function ref(r) {
      scrollAnchor = r;
    },
    className: CSSPrefix_1.prefixEnumClassNames(utils_1.DomUtils.cleanupClassNames([nextTheme, CSSPrefix_1.lsgPre + "stage-leadtext__outside-wrapper"]))
  }, React.createElement(Paragraph_1.Paragraph, {
    className: CSSPrefix_1.lsgPre + "stage-leadtext__outside",
    size: Paragraph_1.Paragraph.Sizes.LEAD
  }, leadText)));
};

exports.Stage.defaultProps = defaultProps;
exports.Stage.displayName = "Stage";